import { cn } from '@/utils'

export const StepsToggledOffIcon = ({
  className,
  color = '#1E1E1E',
}: {
  className?: string
  color?: string
}) => {
  return (
    <svg
      width="31"
      height="23"
      viewBox="0 0 31 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
    >
      <path
        d="M12.3229 2.65364C12.0985 2.55239 11.8547 2.5 11.6081 2.5C11.3615 2.5 11.1178 2.55239 10.8934 2.65364L3.51369 5.97586C3.36089 6.04251 3.23097 6.15168 3.13977 6.29007C3.04856 6.42846 3 6.5901 3 6.7553C3 6.92051 3.04856 7.08215 3.13977 7.22054C3.23097 7.35893 3.36089 7.4681 3.51369 7.53475L10.902 10.8655C11.1264 10.9666 11.3702 11.0189 11.6167 11.0188C11.8633 11.0189 12.1071 10.9666 12.3315 10.8655L19.7198 7.54327C19.8729 7.47673 20.003 7.36756 20.0944 7.22907C20.1858 7.09059 20.2345 6.92878 20.2345 6.7634C20.2345 6.59801 20.1858 6.43621 20.0944 6.29772C20.003 6.15924 19.8729 6.05006 19.7198 5.98353L12.3229 2.65364Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11.0186C2.9996 11.1815 3.04643 11.3411 3.13495 11.4785C3.22348 11.6159 3.34998 11.7253 3.49945 11.7937L10.905 15.1245C11.1282 15.2244 11.3704 15.2761 11.6154 15.2761"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15.2778C2.9996 15.4408 3.04643 15.6004 3.13495 15.7378C3.22348 15.8752 3.34998 15.9846 3.49945 16.053L10.905 19.3838C11.1282 19.4837 11.3704 19.5355 11.6154 19.5355C11.8604 19.5355 12.1026 19.4837 12.3258 19.3838L14.1479 18.5643"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7812 14.3396C15.7812 14.3396 18.0775 9.79639 22.0961 9.79639C26.1146 9.79639 28.4109 14.3396 28.4109 14.3396C28.4109 14.3396 26.1146 18.8828 22.0961 18.8828C18.0775 18.8828 15.7812 14.3396 15.7812 14.3396Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0961 16.0433C23.0472 16.0433 23.8183 15.2805 23.8183 14.3396C23.8183 13.3987 23.0472 12.6359 22.0961 12.6359C21.1449 12.6359 20.3738 13.3987 20.3738 14.3396C20.3738 15.2805 21.1449 16.0433 22.0961 16.0433Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
